import api from "../../apiConfig";
import { useContext } from 'react';
import { AccountContext } from '../../AccountContext';
import UserPool from '../../UserPool';

export const returnSubjectPropParams = (subjectProperty) => {
    return {
        Br: parseFloat(subjectProperty.Br),
        Bath_tot: parseFloat(subjectProperty.Bath_tot),
        Park_spcs: subjectProperty.Park_spcs,
        Bsmt1_out: subjectProperty.Bsmt1_out,
        Yr_built: subjectProperty.Yr_built,
        A_c: subjectProperty.A_c,
        Sqft: subjectProperty.Sqft,
        Latitude: subjectProperty.Latitude,
        Longitude: subjectProperty.Longitude
    }
}

export const fetchImages = async (home, setImages, setLoading) => {
    if (!home || !home.Ml_num) {
        setImages([]);
        setLoading(false);
        return;
    }

    try {
        const response = await api.get('/images', {
            params: { ml_number: home.Ml_num },
        });
        setImages(response.data.images);
    } catch (error) {
        console.error('Error fetching images:', error);
        setImages([]);
    } finally {
        setLoading(false);
    }
}

// Authentication utility hook
export const useAuth = () => {
  const { isAuthenticated, setIsAuthenticated, logout } = useContext(AccountContext);

  const checkSessionValidity = () => {
    return new Promise((resolve) => {
      const user = UserPool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err || !session || !session.isValid()) {
            resolve(false);
          } else {
            resolve(true);
          }
        });
      } else {
        resolve(false);
      }
    });
  };

  const validateSessionAndLogout = async () => {
    const isValid = await checkSessionValidity();
    if (!isValid) {
      logout();
      return false;
    }
    return true;
  };

  return {
    isAuthenticated,
    setIsAuthenticated,
    checkSessionValidity,
    validateSessionAndLogout,
    logout
  };
};

export const getDisplayAddress = (property) => {
  return property?.full_address || property?.Addr || 'No Address';
};
